import React from "react";
import "./Feature.scss";
import FeatureCard from "./FeatureCard/FeatureCard";
import img1 from "../../images/undraw_fast_loading_re_8oi3.svg";
import img2 from "../../images/undraw_Responsive_re_e1nn.svg";
import img3 from "../../images/undraw_Success_factors_re_ce93.svg";

import img4 from "../../images/undraw_mobile_devices_k1ok.svg";

const Features = () => {
  return (
    <div className="features mt-5 container">
      <h6 className="heading" id="features">
        Features
      </h6>
      <div className="row cards-design">
        <FeatureCard title="Fast Loading Websites" image={img1} />
        <FeatureCard title="Responsive Websites" image={img2} />
        <FeatureCard title="Interactive Websites" image={img3} />
        <FeatureCard title="Mobile Friendly Websites" image={img4} />
      </div>
    </div>
  );
};

export default Features;
